import { Fragment } from "react";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import LazyLoadComponent from "../../Image/LazyLoad";
import { SiteContext } from "../../../Contexts/SiteContext";
import { selectImageForDevice } from "../../../../utils";
import { getBlockId } from "../../../../utils/forms/form.fields.utils";
import { LightIcon } from "../../Icons/light";

const SliderControls = props => {
	const { block, block: { data } } = props;

	const [x, setX] = useState(0);
	const [activeIndex, setActiveIndex] = useState(0);
	const [sliderData, setSliderData] = useState(data);

	const left = () => {
		if (x === 0) {
			setX(-100 * (data.length - 1));
		} else {
			setX(x + 100);
		}
	};

	const right = () => {
		if (x === -100 * (data.length - 1)) {
			setX(0);
		} else {
			setX(x - 100);
		}
	};


	// TODO: Dynamically update size for slider from backend.
	const setSlideHeight = (deviceType) => {
		switch (deviceType) {
			case "desktop":
				return "725px";
			case "tablet":
				return "507px"
			case "mobile":
				return "270px";
		}
	}

	useEffect(() => {
		setActiveIndex((x / 100) * -1);
	}, [x]);


	return (
		<SiteContext.Consumer>
			{({ deviceType }) => (
				<Fragment>
					<div className="slider_wrapper mt64px" style={{ height: setSlideHeight(deviceType) }} id={getBlockId(block)}>
						<div className="slider">
							{sliderData.length && sliderData.map((tl, i) => {
								return (
									<div className="slider-item" key={`timeline-media-${i}`} style={{ transform: `translateX(${x}%)` }}>
										<div className="slide-item__wrapper">
											{tl.media !== null && tl.media.desktop !== null &&
												<LazyLoadComponent
													image={selectImageForDevice(deviceType, tl)}
													alt={tl.title}
												/>
											}
										</div>
									</div>
								);
							})}
							<ul className={`timelineSteps`}>
								{sliderData.length && sliderData.map((tl, i) => {
									return (
										<li
											className={`item ${activeIndex === i && "active"
												}`}
											key={`timelineLi-${tl.media.id}-${i}`}
											onClick={() => {
												setX((i * 100) * -1);
											}}
										>
											<div className="icon">
												<div>
													<p>{tl.title}</p>
												</div>
											</div>
											{i !== sliderData.length - 1 && (
												<div className="line">
													<span></span>
												</div>
											)}
										</li>
									);
								})}
							</ul>
						</div>

						{sliderData != null ? (activeIndex - 1 >= 0 &&
							<motion.div
								className="left control"
								onClick={() => {
									left();
								}}
							>
								<LightIcon
									icon={{
										icon: "angle-left", size: "4x"
									}}
								/>
							</motion.div >) : null
						}

						{sliderData != null ? (activeIndex + 1 != sliderData.length &&
							<motion.div
								className="right control"
								onClick={() => {
									right();
								}}
							>
								<LightIcon
									icon={{
										icon: "angle-right", size: "4x"
									}}
								/>
							</motion.div>) : null
						}
					</div>
				</Fragment>
			)}
		</SiteContext.Consumer>
	);
};

export default SliderControls;